import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: -2px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  min-width: 0;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  flex-shrink: 0;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { ImageAbsolute } from '../../Image';
import Flex from '../../Flex';
import { Base, LinkBase, Small } from '../../Typography';
import { INFO_AGENT_PROFILE_IMAGE_MEDIUM_MARGIN, INFO_AGENT_PROFILE_IMAGE_MEDIUM_SIZE, INFO_AGENT_PROFILE_IMAGE_SMALL_MARGIN, INFO_AGENT_PROFILE_IMAGE_SMALL_SIZE } from './constants';
import InfoContentSimple from '../InfoContent/InfoContentSimple';
import { $showMixin } from '../../mixins/layout';
import { EMPTY_PROPS } from '../../helpers';
import { circleContainerStyle } from '../../tokens/circle';
import { baseEllipsisStyle } from '../../tokens/ellipsis';
import { alignSelf, marginRight, size } from '../../style';
var SIZE = {
  small: INFO_AGENT_PROFILE_IMAGE_SMALL_SIZE,
  medium: INFO_AGENT_PROFILE_IMAGE_MEDIUM_SIZE
};
var MARGIN_RIGHT = {
  small: INFO_AGENT_PROFILE_IMAGE_SMALL_MARGIN,
  medium: INFO_AGENT_PROFILE_IMAGE_MEDIUM_MARGIN
};
var ProfileImageContainer = styled.div(_templateObject(), $showMixin, circleContainerStyle, function (_ref) {
  var _SIZE$$size;

  var $size = _ref.$size;
  return size((_SIZE$$size = SIZE[$size]) != null ? _SIZE$$size : SIZE.small);
}, function (_ref2) {
  var _MARGIN_RIGHT$$size;

  var $size = _ref2.$size;
  return marginRight((_MARGIN_RIGHT$$size = MARGIN_RIGHT[$size]) != null ? _MARGIN_RIGHT$$size : MARGIN_RIGHT.small);
}, function (_ref3) {
  var $alignY = _ref3.$alignY;
  return alignSelf($alignY);
});
var ProfileDataContainer = styled(Flex)(_templateObject2(), $showMixin);
var ProfileDataInnerContainer = styled.div(_templateObject3());
var LinkWrapper = styled(Small)(_templateObject4(), baseEllipsisStyle);
var StyledLinkBase = styled(LinkBase)(_templateObject5());
var InfoAgent = /*#__PURE__*/React.forwardRef(function (_ref4, forwardedRef) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 'small' : _ref4$size,
      _ref4$profileAlignY = _ref4.profileAlignY,
      profileAlignY = _ref4$profileAlignY === void 0 ? 'center' : _ref4$profileAlignY,
      profileImage = _ref4.profileImage,
      profileImageUrl = _ref4.profileImageUrl,
      _ref4$profileImageAlt = _ref4.profileImageAlt,
      profileImageAlt = _ref4$profileImageAlt === void 0 ? '' : _ref4$profileImageAlt,
      _ref4$profileImagePro = _ref4.profileImageProps,
      profileImageProps = _ref4$profileImagePro === void 0 ? EMPTY_PROPS : _ref4$profileImagePro,
      profileName = _ref4.profileName,
      _ref4$profileLines = _ref4.profileLines,
      profileLines = _ref4$profileLines === void 0 ? 1 : _ref4$profileLines,
      hintTitle = _ref4.hintTitle,
      _ref4$hintMuted = _ref4.hintMuted,
      hintMuted = _ref4$hintMuted === void 0 ? false : _ref4$hintMuted,
      _ref4$hintLines = _ref4.hintLines,
      hintLines = _ref4$hintLines === void 0 ? 1 : _ref4$hintLines,
      linkTitle = _ref4.linkTitle,
      linkHref = _ref4.linkHref,
      linkTarget = _ref4.linkTarget,
      _ref4$linkProps = _ref4.linkProps,
      linkProps = _ref4$linkProps === void 0 ? EMPTY_PROPS : _ref4$linkProps,
      onLinkClick = _ref4.onLinkClick,
      _ref4$showImage = _ref4.showImage,
      showImage = _ref4$showImage === void 0 ? true : _ref4$showImage,
      _ref4$showInfo = _ref4.showInfo,
      showInfo = _ref4$showInfo === void 0 ? true : _ref4$showInfo,
      _ref4$inverse = _ref4.inverse,
      inverse = _ref4$inverse === void 0 ? false : _ref4$inverse,
      textAlign = _ref4.textAlign,
      props = _objectWithoutPropertiesLoose(_ref4, ["size", "profileAlignY", "profileImage", "profileImageUrl", "profileImageAlt", "profileImageProps", "profileName", "profileLines", "hintTitle", "hintMuted", "hintLines", "linkTitle", "linkHref", "linkTarget", "linkProps", "onLinkClick", "showImage", "showInfo", "inverse", "textAlign"]);

  return /*#__PURE__*/React.createElement(Flex, _extends({
    ref: forwardedRef,
    direction: 'ltr',
    justifyContent: 'flex-start',
    alignItems: 'center'
  }, props), /*#__PURE__*/React.createElement(ProfileImageContainer, {
    $size: size,
    $alignY: profileAlignY,
    $show: showImage
  }, profileImage || /*#__PURE__*/React.createElement(ImageAbsolute, _extends({
    src: profileImageUrl,
    alt: profileImageAlt
  }, profileImageProps))), /*#__PURE__*/React.createElement(ProfileDataContainer, {
    fullWidth: true,
    direction: 'ttb',
    $show: showInfo
  }, /*#__PURE__*/React.createElement(ProfileDataInnerContainer, null, /*#__PURE__*/React.createElement(InfoContentSimple, {
    component: Base,
    title: profileName,
    lines: profileLines,
    strong: true,
    inverse: inverse,
    textAlign: textAlign
  }), /*#__PURE__*/React.createElement(InfoContentSimple, {
    component: Small,
    title: hintTitle,
    lines: hintLines,
    muted: hintMuted,
    inverse: inverse,
    textAlign: textAlign
  }), linkTitle && /*#__PURE__*/React.createElement(LinkWrapper, {
    as: 'div'
  }, /*#__PURE__*/React.createElement(StyledLinkBase, _extends({
    variant: 'primary',
    strong: true,
    ellipsis: true,
    href: linkHref,
    target: linkTarget,
    onClick: onLinkClick,
    textAlign: textAlign
  }, linkProps), linkTitle)))));
});
export default InfoAgent;